import {SET_ERROR} from "../Redux/Actions/Types/errorActionTypes";
import {useDispatch} from "react-redux";

export const useShowPermissionDenied = () => {
    const dispatch = useDispatch();

    return () => {
        dispatch({
            type: SET_ERROR,
            error: {
                Code: 403,
                Message: 'Permission Denied',
                Title: 'Forbidden',
            }
        });
    };
};

export const useDefaultErrorHandler = () => {
    const dispatch = useDispatch();

    return (error) => {
        if (error?.message) {
            dispatch({
                type: SET_ERROR,
                error: {
                    Code: error?.xhr?.status ?? null,
                    Message: error?.message,
                    Title: error?.xhr?.statusText ?? 'Error',
                    StackTrace: error?.data?.stackTrace
                }
            });
        } else if (error instanceof Error) {
            throw error;
        }
    }
};
